import React,{useEffect, useState} from 'react'
import {Container,Row,Col,Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getMachineries, removeMachinery } from '../../../actions/machineriesActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Machineries() {
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true)
    const {machineries, loading, result} = useSelector(state=>state.machineries)
    const dispatch = useDispatch()

    useEffect(()=>{
        dispatch(getMachineries())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('machineries.itsok'),
                    icon: 'error',
                    text: t('machineries.'+result.message+'0') + result.count + t('machineries.'+result.message+'1')
                })
                dispatch({
                    type: 'MACHINERY_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('machineries.letsok'),
                    icon: 'success',
                    text: t('machineries.deletedmachinery')
                })
                dispatch({
                    type: 'MACHINERY_RESET_RESULT'
                })
            }
        }
    }, [result, t, dispatch])

    const deleteMachinery = (idMachinery) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeMachinery(idMachinery))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    // Datatables
    const columns = [
        {
            name: t('machineries.name'),
            cell: datos =>
                <div>
                    {datos.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('machineries.description'),
            cell: datos =>
                <div>
                    {datos.description}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('machineries.plate'),
            cell: datos =>
                <div>
                    {datos.plate}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('machineries.type'),
            cell: datos =>
                <div>
                    {datos.type}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/machinery/`+datos._id}>
                    <i className="fas fa-tractor"></i> <i className="fas fa-edit fa-sm"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deleteMachinery(datos._id)}>
                    <i className="fas fa-tractor"></i> <i className="fas fa-minus fa-sm"></i>
                </Button>
            </>
        }
    ]

    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>        
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('machineries.editmachinery')}</h1> 
                        <label className='mb-2'>{t('machineries.selectmachinery')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/machinery`}>
                                <i className="fas fa-tractor"></i> {t('machineries.add')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {machineries 
                                ?
                                    <CustomDataTable columns={columns} data={machineries} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}